<mat-card
  [@cardAnimator]="animationState"
  (@cardAnimator.done)="resetAnimationState()"
  class="contrast mat-card-inline-sm"
  [class.banner-info]="selected">
  <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="90" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column" fxLayoutGap.lt-sm="5px">
      <asset-upload #assetUploadComponent
          [hideButtons]="true"
          (asset)="onAssetLoad($event)">
          <div class="image-container" fxLayout="row" fxLayoutAlign="center center">
            <ng-container *ngIf="!thumbnailData && thumbnailUrl">
              <img [lazyLoad]="thumbnailUrl" class="thumbnail">
              
              <div class="overlay-icon" fxLayout="row" fxLayoutAlign="end center">
                <button class="small-icon" mat-icon-button color="accent" matTooltip="Upload new thumbnail" (click)="triggerChildFileUpload($event);">
                  <mat-icon>add_photo_alternate</mat-icon>
                </button>
              </div>
            </ng-container>
    
            <ng-container *ngIf="thumbnailData">
              <img [src]="thumbnailData" class="thumbnail">
                 
              <div class="overlay-icon" fxLayout="column" fxLayoutAlign="center center">
                <button class="small-icon" mat-icon-button color="primary" matTooltip="Cancel new thumbnail" (click)="cancelThumbnailUpload()">
                  <mat-icon>close</mat-icon>
                </button>
                <button class="small-icon" mat-icon-button color="accent" matTooltip="Save new thumbnail" (click)="saveThumbnailUpload()">
                  <mat-icon>done</mat-icon>
                </button>
              </div>
            </ng-container>
            
            <ng-container *ngIf="!thumbnailData && !thumbnailUrl">
              <img src="/assets/images/add-image-icon.svg" class="thumbnail banner-incomplete">
              
              <div class="overlay-icon" fxLayout="row" fxLayoutAlign="end center">
                <button class="small-icon" mat-icon-button color="accent" matTooltip="Upload new thumbnail" (click)="triggerChildFileUpload($event);">
                  <mat-icon>add_photo_alternate</mat-icon>
                </button>
              </div>
            </ng-container>
          </div>
        </asset-upload>
      <div fxLayoutAlign="center start" fxLayout="column">
        <!-- <img *ngIf="companyLogo" class="product-company-logo"
            [lazyLoad]="companyLogo"
            matTooltip="Show {{ companyName }} products"> -->
        <small class="text-info" *ngIf="companyName">{{ companyName }}</small>
        <strong [ngClass.lt-sm]="{'card-title': true}" [class.readonly]="readonly" [innerHtml]="name | highlight: searchValue"></strong>
        <small [class.readonly]="readonly" fxFlex="100" *ngIf="showCategory">{{ category }}</small>
      </div>
    </div>
    <div fxFlex="10" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
      <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
        <button *ngIf="showSwap && !readonly" mat-icon-button [color]="selected ? 'primary' : 'basic'" (click)="swap()" matTooltip="Swap Style">
          <mat-icon>swap_horiz</mat-icon>
        </button>
        <button *ngIf="showClear" mat-icon-button color="basic" (click)="clear()" matTooltip="Clear Style">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>